import type { MisconceptionDefinition } from './types';

/** SWW — Spelling werkwoorden misconcepties. */
export const SWW_MISCONCEPTIONS: MisconceptionDefinition[] = [{
  id: 'sww.kofschip-misapplied',
  label: 'Kofschip verkeerd toegepast',
  module: 'SpellingWW',
  description: 'Leerling past de kofschip-regel verkeerd toe bij voltooid deelwoord.',
  typicalFamilies: ['SWW-VD-KOF', 'SWW-VT-ZWAK-KOF']
}, {
  id: 'sww.stem-extraction-error',
  label: 'Stam verkeerd bepaald',
  module: 'SpellingWW',
  description: 'Leerling bepaalt de stam van het werkwoord verkeerd (bijv. "leeft" → stam "leef" i.p.v. "leev").',
  typicalFamilies: ['SWW-TT-STAM', 'SWW-TT-DSTAM']
}, {
  id: 'sww.past-participle-ge-omitted',
  label: 'Ge- weggelaten',
  module: 'SpellingWW',
  description: 'Leerling vergeet ge- bij het voltooid deelwoord (of voegt het onterecht toe).',
  typicalFamilies: ['SWW-VD-ZONDER-GE']
}, {
  id: 'sww.irregular-verb-regularized',
  label: 'Onregelmatig werkwoord vervoegd als regelmatig',
  module: 'SpellingWW',
  description: 'Leerling past regelmatige vervoegingsregels toe op een onregelmatig werkwoord.',
  typicalFamilies: ['SWW-VT-ONREGELMATIG', 'SWW-VD-STERK']
}];